// extracted by mini-css-extract-plugin
module.exports = {"socialContainer":"SocialFollow_socialContainer__2G0W6","social":"SocialFollow_social__2X98r","facebook":"SocialFollow_facebook__14qE0","twitter":"SocialFollow_twitter__FGxdg"};